// @flow
import React from 'react'

import FlyerGridMenuDropdown from './FlyerGridMenuDropdown'
import FlyerDropdownTrigger from './DropdownTrigger'

type Props = {
  className: string,
  handleChange: any => any,
  defaultValue: string,
  options: Array<{ text: string, value: string }>,
  currentOption: { text: string, value: string }
}

const FlyerSortDropdown = (props: Props) => {
  const { currentOption } = props

  return (
    <FlyerGridMenuDropdown
      {...props}
      trigger={<FlyerDropdownTrigger value={currentOption.text} label="Sort" />}
    />
  )
}

export default FlyerSortDropdown



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerGrid/components/FlyerGridMenu/components/FlyerSortDropdown.js